// File: CustomProfile.jsx
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import Slider from "react-slick";
import Cropper from "react-easy-crop";
import { toast } from "react-toastify";
import { BiEdit } from "react-icons/bi";
import { Button } from "react-bootstrap";
import { LuUpload } from "react-icons/lu";
import { VscPreview } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MdOutlineDesignServices, MdOutlineWidgets } from "react-icons/md";
import "../../Assets/css/CustomProfile.css";
import {
  faChartLine,
  faShareAlt,
  faSignOutAlt,
  faFilePdf,
  faStar,
  faBars,
  faPlus,
  faCog,
  faImages,
  faLink,
  faUpload,
  faLock,
  faTrash,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import FormModal from "./FormModal";
import WidgetMenu from "./WidgetMenu";
import CountdownModal from "./CountdownModal";
import user from "../../Assets/photo/user.png";
import AlbumEmbedModal from "./AlbumEmbedModal";
import WidgetComponent from "./WidgetComponent";
import axiosUserInstance from "../../axiosUserInstance";
import { useLoader } from "../../context/LoaderContext";
import helpPdf from "../../Assets/PDF/BioME-Help-Guide.pdf";
import { hexToRgba, uploadFileToS3 } from "../../utils/common";
import {
  APP_BASE_URL,
  settings1x,
  settings2x,
  staticThemeList,
} from "../../utils/constant";
import { FaPlay, FaPlus, FaRegLemon } from "react-icons/fa";
import { RxDashboard } from "react-icons/rx";
import { BsFillSendFill } from "react-icons/bs";
import { HiShoppingBag } from "react-icons/hi2";

const localStorageKey = "biome_profile_v1";

function CustomProfile() {
  const navigate = useNavigate();
  const { loading, setLoading } = useLoader();
  const [themeList, setThemeList] = useState([]);
  const [zoom, setZoom] = useState(1);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [showCropModal, setShowCropModal] = useState(false);
  const [openWidgetModal, setOpenWidgetModal] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCountdownModal, setShowCountdownModal] = useState(false);
  const [showAlbumEmbedModal, setShowAlbumEmbedModal] = useState(false);
  const [userData, setUserData] = useState(() => {
    return {
      fullName: "Your Name",
      nickname: "@yournickname",
      bio: "This is your bio. Tell people about yourself, your passions, or what you do. You can edit this in the customization section below.",
      tags: [],
      profilePicture: user,
      bannerImage: "",
      bioScore: 0,
      status: "active",
      audioUrl: "",
      showAudio: false,
      socialLinks: [],
      userWidget: {},
      albums: [],
      storage: { used: 5, total: 20 },
      isPremium: false,
      activeThemeUrl:
        "https://f005.backblazeb2.com/file/biome12/1761668030260-cropped-image.jpg",
      socialLinkTheme: {
        background: "#f9f9f9",
        backgroundOpacity: 1,
        backgroundBorderWidth: 1,
        backgroundBorder: "rgba(0, 0, 0, 0.05)",
        backgroundRadius: 8,
        thumbnailRadius: 8,
        titleColor: "#2d3436",
        subtitleColor: "#777777",
        iconColor: "#777",
        buttonTextColor: "#ffffff",
        buttonBorder: "#6c5ce7",
        buttonBackground: "#f9f9f9",
        buttonRadius: 8,
      },
      pageTheme: {
        background: "#f9f9f9",
        backgroundOpacity: 1,
        backgroundBorderWidth: 1,
        backgroundBorder: "rgba(0, 0, 0, 0.05)",
        backgroundRadius: 8,
        thumbnailRadius: 8,
        titleColor: "#2d3436",
        subtitleColor: "#777777",
        iconColor: "#777",
        buttonTextColor: "#ffffff",
        buttonBorder: "#6c5ce7",
        buttonBackground: "#f9f9f9",
        buttonRadius: 8,
      },
      socialLink: { type: "", link: "", label: "", thumbnailUrl: "" },
      activeAlbumLayout: "grid2",
    };
  });

  const [queueFormData, setQueueFormData] = useState({
    title: "",
    releaseAt: "",
    description: "",
    subType: "link",
    link: "",
    fileLink: "",
    thumbnail: "",
    thumbnailType: "image",
    containerColor: "#edf492",
    textColor: "#000000",
    containerOpacity: 1,
    borderColor: "#000000",
    borderWidth: 1,
  });

  const [albumEmbedFormData, setAlbumEmbedFormData] = useState({
    lightWeightMediaLink: "",
    originalMediaLink: "",
    mediaType: "",
    isLinkEmbed: false,
    embedLink: "",
    ratio: "1:1",
  });

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [modal, setModal] = useState({ open: false, type: "", payload: null });
  const [modalForm, setModalForm] = useState({});
  const [uploadPreview, setUploadPreview] = useState(null);
  const [newTag, setNewTag] = useState(null);

  const [showAll, setShowAll] = useState(false);

  const visibleAlbums = showAll ? userData.albums : userData.albums.slice(0, 4);

  const fileInputRef = useRef(null);

  useEffect(() => {
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(userData));
    } catch (e) {}
  }, [userData]);

  useEffect(() => {
    const userInfo = localStorage.getItem("userInfo");
    const userDetails =
      userInfo && typeof userInfo === "string" ? JSON.parse(userInfo) : null;
    if (userDetails?.userId) {
      fetchUserData();
    }
  }, []);

  const fetchUserData = async () => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.get(`/user/data`);
      if (response?.status === 200) {
        const data = await response.data?.data;
        setUserData((prev) => ({
          ...prev,
          fullName: data.name || prev.fullName,
          status: data.status,
          nickname: `@${data.userName}`,
          bio: data.bio || prev.bio,
          bioScore: data.bioScore || 0,
          bannerImage: data?.bannerImage || prev.bannerImage,
          profilePicture: data.profileImage || prev.profilePicture,
          audioUrl: data.audioUrl || prev.audioUrl,
          showAudio: data.showAudio || false,
          socialLinks:
            data.socialLinks?.length > 0 ? data.socialLinks : prev.socialLinks,
          tags: data.tags?.length > 0 ? data.tags : [],
          userWidget:
            data?.userWidget && Object.keys(data?.userWidget)?.length > 0
              ? data?.userWidget
              : {},
          albums: data.albums?.length > 0 ? data.albums : [],
          storage: {
            used: data?.totalStorageUsed || 0,
            total: data?.planType?.limit,
          },
          isPremium:
            data?.planType?.type === "monthly" ||
            data?.planType?.type === "yearly",
          planType: data?.planType?.type || "free",
          activeThemeUrl: data.activeThemeUrl || prev.activeThemeUrl,
          socialLinkTheme: data.socialLinkTheme || prev.socialLinkTheme,
          pageTheme: data.pageTheme || prev.pageTheme,
          activeAlbumLayout: data.activeAlbumLayout || prev.activeAlbumLayout,
        }));
        const updatedthemeUrls = data?.themeUrls?.map((item) => ({
          ...item,
          isPremium: false,
        }));
        setThemeList(updatedthemeUrls || []);
      } else {
        console.log(
          "error ==>",
          response?.message || "Login failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  const updateUserData = async (payload) => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.put(`/user/update`, payload);
      if (response?.status === 200) {
        const data = await response.data?.data;
        setUserData((prev) => ({
          ...prev,
          fullName: data.name || prev.fullName,
          status: data.status,
          nickname: `@${data.userName}`,
          bio: data.bio || prev.bio,
          bioScore: data.bioScore || 0,
          showAudio: data.showAudio || false,
          bannerImage: data?.bannerImage || prev.bannerImage,
          profilePicture: data.profileImage || prev.profilePicture,
          socialLinks:
            data.socialLinks?.length > 0 ? data.socialLinks : prev.socialLinks,
          tags: data.tags?.length > 0 ? data.tags : [],
          albums: data.albums?.length > 0 ? data.albums : [],
          activeThemeUrl: data.activeThemeUrl || prev.activeThemeUrl,
          socialLinkTheme: data.socialLinkTheme || prev.socialLinkTheme,
          pageTheme: data.pageTheme || prev.pageTheme,
          activeAlbumLayout: data.activeAlbumLayout || prev.activeAlbumLayout,
        }));
        toast.success("Profile updated successfully.");
      } else {
        toast.error(
          response?.message || "Profile update failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTheme = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const response = await axiosUserInstance.delete(
            `/themeUrl/delete/${id}`,
          );
          if (response?.status === 200) {
            const updatedTheme = themeList?.filter((item) => item?._id !== id);
            setThemeList(updatedTheme || []);
            toast.success("Theme deleted successfully.");
          } else {
            toast.error(
              response?.message || "Theme delete failed. Please try again.",
            );
          }
        } catch (err) {
          const apiError =
            err?.response?.data?.message ||
            err?.message ||
            "An error occurred. Please try again.";
          toast.error(apiError);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleDeleteProfile = async (e, payload) => {
    e.preventDefault();
    e.stopPropagation();
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const response = await axiosUserInstance.put(
            `/user/profileImage/delete`,
            payload,
            { isDeleteProfileImage: true, isDeleteBannerImage: true },
          );
          if (response?.status === 200) {
            toast.success("User profile deleted successfully.");
            if (payload?.isDeleteBannerImage) {
              setUserData((prev) => ({
                ...prev,
                bannerImage: "",
              }));
            }
            if (payload?.isDeleteProfileImage) {
              setUserData((prev) => ({
                ...prev,
                profilePicture: user,
              }));
            }
          } else {
            toast.error(
              response?.message ||
                "User profile delete failed. Please try again.",
            );
          }
        } catch (err) {
          const apiError =
            err?.response?.data?.message ||
            err?.message ||
            "An error occurred. Please try again.";
          toast.error(apiError);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const createSoicalLinks = async (payload) => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.post(`/widget/add`, {
        type: "socialLink",
        socialLink: payload,
      });
      if (response?.status === 200 || response?.status === 201) {
        const updatedWidget = response.data?.data;
        const links =
          updatedWidget?.widgets
            .filter((w) => w?.type === "socialLink")
            .map((w) => ({ _id: w._id, ...w?.socialLink })) || [];
        setUserData((u) => ({
          ...u,
          userWidget: updatedWidget,
          socialLinks: links,
        }));
        toast.success("Social link created successfully.");
      } else {
        toast.error(
          response?.message || "Social link create failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  const updateSoicalLinks = async (id, payload) => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.post(`/widget/edit`, {
        _id: id,
        ...payload,
      });
      if (response?.status === 200) {
        const updatedWidget = response.data?.data;
        const links =
          updatedWidget?.widgets
            .filter((w) => w.type === "socialLink")
            .map((w) => ({ _id: w._id, ...w.socialLink })) || [];
        setUserData((u) => ({
          ...u,
          userWidget: updatedWidget,
          socialLinks: links,
        }));
        toast.success("Social link updated successfully.");
      } else {
        toast.error(
          response?.message || "Social link update failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  const createAlbums = async (payload) => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.post(`/albums/create`, payload);
      if (response?.status === 201) {
        toast.success("Albums created successfully.");
      } else {
        toast.error(
          response?.message || "Albums create failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  const updateAlbums = async (id, payload) => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.put(
        `/albums/update/${id}`,
        payload,
      );
      if (response?.status === 200) {
        toast.success("Albums updated successfully.");
      } else {
        toast.error(
          response?.message || "Albums update failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  function toggleMobileNav() {
    setMobileNavOpen((s) => !s);
  }

  function cycleStatus() {
    updateUserData({
      status:
        userData.status === "active"
          ? "sleeping"
          : userData.status === "sleeping"
            ? "busy"
            : "active",
    });
    setUserData((prev) => {
      const order = ["active", "sleeping", "busy"];
      const next = order[(order.indexOf(prev.status) + 1) % order.length];
      return { ...prev, status: next };
    });
  }

  function openModal(type, payload = null) {
    const form = {};
    if (type === "Name") form.name = payload || userData.fullName;
    if (type === "Username")
      form.nickname = (payload || userData.nickname).replace(/^@/, "");
    if (type === "Bio") form.bio = payload || userData.bio;
    if (type === "Profile Picture") form.fileKey = "profilePicture";
    if (type === "Banner Image") form.fileKey = "bannerImage";
    if (type === "Social Link") {
      if (typeof payload === "object" && payload && payload?._id) {
        form.type = payload.type;
        form.link = payload.link;
        form.label = payload.label;
        form.thumbnailUrl = payload.thumbnailUrl;
        form._id = payload._id;
      } else {
        form.socialLink = {
          type: "instagram",
          link: "",
          label: "",
          thumbnailUrl: "",
        };
      }
    }
    if (type === "Albums") {
      if (typeof payload === "number") {
        const album = userData.albums[payload];
        form.name = album.name;
        form.media = album.media;
        form._id = album._id;
        form.index = payload;
      } else {
        form.name = "";
        form.media = [];
      }
    }
    if (type === "Social Link Theme") {
      form.background = userData?.socialLinkTheme?.background || "";
      form.backgroundBorderWidth =
        userData?.socialLinkTheme?.backgroundBorderWidth || 0;
      form.backgroundBorder = userData?.socialLinkTheme?.backgroundBorder || "";
      form.backgroundOpacity =
        userData?.socialLinkTheme?.backgroundOpacity || 1;
      form.backgroundRadius = userData?.socialLinkTheme?.backgroundRadius || "";
      form.thumbnailRadius = userData?.socialLinkTheme?.thumbnailRadius || "";
      form.titleColor = userData?.socialLinkTheme?.titleColor || "";
      form.subtitleColor = userData?.socialLinkTheme?.subtitleColor || "";
      form.iconColor = userData?.socialLinkTheme?.iconColor || "";
      form.buttonTextColor = userData?.socialLinkTheme?.buttonTextColor || "";
      form.buttonBorder = userData?.socialLinkTheme?.buttonBorder || "";
      form.buttonBackground = userData?.socialLinkTheme?.buttonBackground || "";
      form.buttonRadius = userData?.socialLinkTheme?.buttonRadius || "";
    }
    setUploadPreview(null);
    setModalForm(form);
    setModal({ open: true, type, payload });
  }

  function closeModal() {
    setModal({ open: false, type: "", payload: null });
    setModalForm({});
    setUploadPreview(null);
  }

  const onCropComplete = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleUploadCustomTheme = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.match("image.*")) {
      alert("Please select an image file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setShowCropModal(true);
    };
    reader.readAsDataURL(file);
  };

  const getCroppedImg = async (imageSrc, crop) => {
    const image = new Image();
    image.src = imageSrc;
    await new Promise((resolve) => (image.onload = resolve));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height,
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        const file = new File([blob], "cropped-image.jpg", {
          type: "image/jpeg",
        });
        resolve(file);
      }, "image/jpeg");
    });
  };

  const handleCropSave = async () => {
    try {
      setLoading(true);
      const croppedFile = await getCroppedImg(imageSrc, croppedAreaPixels);
      const fileURL = await uploadFileToS3(croppedFile);
      await createTheme({ url: fileURL });
    } catch (err) {
      toast.error("Failed to upload image.");
      console.error(err);
    } finally {
      setShowCropModal(false);
      setImageSrc(null);
      setLoading(false);
    }
  };

  const createTheme = async (payload) => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.post(
        `/themeUrl/create`,
        payload,
      );
      if (response?.status === 201) {
        const data = await response.data?.data;
        setThemeList((prev) => [
          { url: data?.url, isPremium: false, _id: data?._id },
          ...prev,
        ]);
        toast.success("Custom theme upload successfully.");
      } else {
        toast.error(
          response?.message || "Custom theme upload failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  function saveModal(fileURL) {
    switch (modal.type) {
      case "Name":
        setUserData((u) => ({
          ...u,
          fullName: (modalForm.name || "").slice(0, 50),
        }));
        updateUserData({ name: modalForm.name });
        break;
      case "Username":
        Swal.fire({
          title: "Are you sure?",
          text: `Your unique BioME link uses your username as (${APP_BASE_URL}/username). Unless it’s your first time, changing it will make your current link unusable.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Okay, Change it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            setUserData((u) => ({
              ...u,
              nickname: `@${(modalForm.nickname || "").slice(0, 20)}`,
            }));
            updateUserData({ userName: modalForm.nickname });
          }
        });
        break;
      case "Bio":
        setUserData((u) => ({
          ...u,
          bio: (modalForm.bio || "").slice(0, 500),
        }));
        updateUserData({ bio: modalForm.bio });
        break;
      case "Profile Picture":
        if (uploadPreview || fileURL) {
          setUserData((u) => ({
            ...u,
            profilePicture: uploadPreview || fileURL,
            storage: { ...u.storage, used: u.storage.used + 2 },
          }));
          updateUserData({ profileImage: uploadPreview || fileURL });
        }
        break;
      case "Banner Image":
        if (uploadPreview || fileURL) {
          setUserData((u) => ({
            ...u,
            bannerImage: uploadPreview || fileURL,
            storage: { ...u.storage, used: u.storage.used + 3 },
          }));
          updateUserData({ bannerImage: uploadPreview || fileURL });
        }
        break;
      case "Social Link": {
        const { type, link, label, thumbnailUrl, _id } = modalForm;
        if (!link) {
          alert("Please enter a URL");
          return;
        }
        const normalizedUrl = link.startsWith("http")
          ? link
          : `https://${link}`;
        if (_id) {
          updateSoicalLinks(_id, {
            socialLink: {
              type,
              link: normalizedUrl,
              label: label || type,
              thumbnailUrl,
            },
          });
        } else {
          createSoicalLinks({
            type,
            link: normalizedUrl,
            label: label || type,
            ...(thumbnailUrl && { thumbnailUrl }),
          });
        }
        break;
      }
      case "Albums": {
        const { index, name, media, _id } = modalForm;
        // if (!name) {
        //   toast.error("Please enter a name for the album");
        //   return;
        // }
        if (media?.length === 0) {
          toast.error("Please enter atleast one media for the album");
          return;
        }
        if (typeof index === "number") {
          if (Number(userData.storage.used) > Number(userData.storage.total)) {
            toast.error(
              "You have reached your storage limit. Please upgrade to premium plan.",
            );
          } else {
            setUserData((u) => {
              const copy = JSON.parse(JSON.stringify(u));
              copy.albums[index] = {
                name,
                _id,
                media,
              };
              return copy;
            });
            if (_id) {
              updateAlbums(_id, { name, media });
            }
          }
        } else {
          if (userData.storage.used > userData.storage.total) {
            toast.error(
              "You have reached your storage limit. Please upgrade to premium plan.",
            );
          } else {
            setUserData((u) => ({
              ...u,
              albums: [
                ...u.albums,
                {
                  name,
                  media,
                },
              ],
            }));
            createAlbums({ name, media });
          }
        }
        break;
      }
      case "Social Link Theme":
        setUserData((u) => ({
          ...u,
          socialLinkTheme: modalForm,
        }));
        updateUserData({ socialLinkTheme: modalForm });
        break;
      case "Page Design Theme":
        setUserData((u) => ({
          ...u,
          pageTheme: modalForm,
        }));
        updateUserData({ pageTheme: modalForm });
        break;
      default:
        break;
    }
    closeModal();
  }

  async function deleteSocial(id) {
    try {
      setLoading(true);
      const response = await axiosUserInstance.delete(`/widget/delete/${id}`);
      if (response?.status === 200) {
        // update both widget and socialLinks
        const updatedWidget = response.data?.data;
        const links =
          updatedWidget?.widgets
            .filter((w) => w.type === "socialLink")
            .map((w) => ({ _id: w._id, ...w.socialLink })) || [];
        setUserData((u) => ({
          ...u,
          userWidget: updatedWidget,
          socialLinks: links,
        }));
        closeModal();
        toast.success("Social link deleted successfully.");
      } else {
        toast.error(
          response?.message || "Social link delete failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  }

  async function deleteAlbums(id) {
    try {
      setLoading(true);
      const response = await axiosUserInstance.delete(`/albums/delete/${id}`);
      if (response?.status === 200) {
        setUserData((u) => ({
          ...u,
          albums: u.albums.filter((item) => item?._id !== id),
        }));
        closeModal();
        toast.success("Album deleted successfully.");
      } else {
        toast.error(
          response?.message || "Albums delete failed. Please try again.",
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  }

  function openAddSocial() {
    openModal("Social Link", null);
  }

  function handleEditSocialClick(socialLinks) {
    openModal("Social Link", socialLinks);
  }

  function shareProfile() {
    const nick = (userData.nickname || "").replace(/^@/, "") || "yourusername";
    const url = `${window.location.origin}/${nick}`;
    setModal({ open: true, type: "Share", payload: { url } });
    setModalForm({ url });
  }

  const handleDeleteTraits = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        updateUserData({
          tags: userData.tags.filter((t) => t._id !== id),
        });
      }
    });
  };

  const handleOpenQueueModal = (item) => {
    setQueueFormData(
      item
        ? {
            ...item,
            releaseAt:
              new Date(item?.releaseAt).toLocaleString() || item?.releaseAt,
          }
        : {},
    );
    setShowCountdownModal(true);
  };

  const handleOpenEmbedAlbumModal = (item) => {
    setAlbumEmbedFormData(item ? item : {});
    setShowAlbumEmbedModal(true);
  };

  const handleCloseCountdownModal = () => {
    setShowCountdownModal(false);
    setQueueFormData({
      title: "",
      releaseAt: "",
      description: "",
      subType: "link",
      link: "",
      fileLink: "",
      thumbnail: "",
      thumbnailType: "image",
      containerColor: "#edf492",
      textColor: "#000000",
      containerOpacity: 1,
      borderColor: "#000000",
      borderWidth: 1,
    });
  };

  const handleCloseAlbumEmbedModal = () => {
    setShowAlbumEmbedModal(false);
    setAlbumEmbedFormData({
      lightWeightMediaLink: "",
      originalMediaLink: "",
      mediaType: "",
      isLinkEmbed: false,
      embedLink: "",
      ratio: "1:1",
    });
  };

  return (
    <div className="profile-container">
      <div className="profile-header">
        <a href="/" className="logo">
          BioME.com
        </a>
        <div style={{ display: "flex", alignItems: "center" }}>
          <button
            style={{ marginRight: 16 }}
            onClick={() => window.open(helpPdf, "_blank")}
            target="_blank"
            rel="noreferrer"
            className="docs-button bg-transparent border-0"
          >
            <FontAwesomeIcon icon={faFilePdf} /> Docs
          </button>
          <button
            className="mobile-nav-toggle"
            onClick={toggleMobileNav}
            aria-label="Toggle nav"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className={`nav-links ${mobileNavOpen ? "active" : ""}`}>
            <a href="dashboard" className="nav-link">
              <FontAwesomeIcon icon={faChartLine} /> Dashboard
            </a>
            <button className="nav-link" onClick={shareProfile}>
              <FontAwesomeIcon icon={faShareAlt} /> Share
            </button>
            <button
              className="nav-link"
              onClick={() => {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                navigate("/auth/login");
              }}
            >
              <FontAwesomeIcon icon={faSignOutAlt} /> Logout
            </button>
          </div>
        </div>
      </div>
      <div
        className="profile-content"
        style={{
          backgroundImage: userData?.activeThemeUrl
            ? `url(${userData?.activeThemeUrl})`
            : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition: "0.5s ease",
        }}
      >
        <div className="profile-preview">
          <div
            className="profile-banner"
            style={{
              background: `url(${userData.bannerImage})`,
              marginBottom: "-70px",
            }}
          >
            <button
              type="button"
              className="upload-overlay-button"
              onClick={() => {
                if (userData.planType === "yearly") {
                  openModal("Banner Image");
                } else {
                  toast.info(
                    "Banner Image feature is available for Premium users only. Please upgrade your plan to access this feature.",
                  );
                }
              }}
            >
              <LuUpload size={20} />
            </button>
            {userData.bannerImage && (
              <button
                type="button"
                className="delete-overlay-button"
                onClick={(e) =>
                  handleDeleteProfile(e, { isDeleteBannerImage: true })
                }
              >
                <RiDeleteBin6Line size={20} />
              </button>
            )}
          </div>

          <div className="profile-picture-container">
            <button
              type="button"
              className="upload-overlay-button"
              onClick={() => openModal("Profile Picture")}
            >
              <LuUpload size={20} />
            </button>
            <button
              type="button"
              className="delete-overlay-button"
              onClick={(e) =>
                handleDeleteProfile(e, { isDeleteProfileImage: true })
              }
            >
              <RiDeleteBin6Line size={20} />
            </button>
            <img
              src={userData.profilePicture}
              alt="Profile"
              className="profile-picture"
            />
          </div>

          <div className="bioscore" title="BioScore">
            <FontAwesomeIcon icon={faStar} />{" "}
            <span style={{ marginLeft: 6 }}>{userData.bioScore}</span>
            <div className="bioscore-tooltip">
              BioScore flaunts an individual's profile popularity. For every 1
              unique view, 3 BioScore is earned!
            </div>
          </div>

          <h1
            className="profile-name customizable"
            onClick={() => openModal("Name")}
            style={{ color: userData?.pageTheme?.titleColor }}
          >
            {userData.fullName}
          </h1>

          <div
            className="status-indicator"
            onClick={cycleStatus}
            title="Click to change status"
          >
            <div className={`status-dot ${userData.status}`}></div>
            <span className="status-text">
              {userData.status.charAt(0).toUpperCase() +
                userData.status.slice(1)}
            </span>
          </div>

          <div className="profile-traits">
            {userData.tags
              ?.filter((item) => item?.isActive)
              ?.map((t, i) => (
                <div key={t._id} className="trait-pill">
                  {t?.name}
                </div>
              ))}
          </div>

          <h2
            className="profile-nickname customizable"
            onClick={() => openModal("Username")}
            style={{ color: userData?.pageTheme?.subtitleColor }}
          >
            {userData.nickname}
          </h2>
          <p
            className="profile-bio customizable"
            onClick={() => openModal("Bio")}
            style={{ color: userData?.pageTheme?.subtitleColor }}
          >
            {userData.bio}
          </p>
        </div>

        {userData?.socialLinks && userData?.socialLinks?.length > 0 && (
          <>
            {/* <div className="section-title social-title">
              <div>
                <FontAwesomeIcon icon={faLink} /> Social Links
              </div>
              <button
                className="add-social-link"
                type="button"
                onClick={() => openModal("Social Link Theme")}
              >
                Design Link
              </button>
            </div> */}
            {/* <div className="social-links">
              {userData.socialLinks.map((link, i) => (
                <div
                  key={i}
                  style={{ display: "flex", gap: 12, alignItems: "center" }}
                >
                  <a
                    className="social-link"
                    href={link.link}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      backgroundColor: hexToRgba(
                        userData?.socialLinkTheme?.background,
                        userData?.socialLinkTheme?.backgroundOpacity,
                      ),
                      border: `${userData?.socialLinkTheme?.backgroundBorderWidth}px solid ${userData?.socialLinkTheme?.backgroundBorder}`,
                      borderRadius: `${userData?.socialLinkTheme?.backgroundRadius}px`,
                      color: userData?.socialLinkTheme?.titleColor,
                    }}
                  >
                    <img
                      src={link.thumbnailUrl || user}
                      alt={link.label}
                      className="social-thumbnail"
                      style={{
                        borderRadius: `${userData?.socialLinkTheme?.thumbnailRadius}px`,
                      }}
                    />
                    {link.type === "lemon8" ? (
                      <>
                        <FaRegLemon
                          className="social-platform-icon"
                          color={userData?.socialLinkTheme?.iconColor}
                        />
                      </>
                    ) : link.type === "shop" ? (
                      <>
                        <HiShoppingBag
                          className="social-platform-icon"
                          color={userData?.socialLinkTheme?.iconColor}
                        />
                      </>
                    ) : (
                      <i
                        className={`social-platform-icon fab fa-${link.type}`}
                        style={{ color: userData?.socialLinkTheme?.iconColor }}
                      ></i>
                    )}
                    <div className="social-info">
                      <div
                        className="social-label"
                        style={{ color: userData?.socialLinkTheme?.titleColor }}
                      >
                        {link.label}
                      </div>
                      <div
                        className="social-url"
                        style={{
                          color: userData?.socialLinkTheme?.subtitleColor,
                        }}
                      >
                        {link.link}
                      </div>
                    </div>
                    <button
                      className="btn btn-outline edit-btn"
                      onClick={(e) => {
                        handleEditSocialClick(i);
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      style={{
                        backgroundColor:
                          userData?.socialLinkTheme?.buttonBackground,
                        border: `1px solid ${userData?.socialLinkTheme?.buttonBorder}`,
                        borderRadius: `${userData?.socialLinkTheme?.buttonRadius}px`,
                        color: userData?.socialLinkTheme?.buttonTextColor,
                      }}
                    >
                      <BiEdit size={18} />
                    </button>
                  </a>
                </div>
              ))}
            </div> */}
          </>
        )}

        <div className="section-title social-title">
          <div style={{ color: userData?.pageTheme?.titleColor }}>
            <FontAwesomeIcon icon={faImages} /> Albums
          </div>
        </div>
        {userData?.activeAlbumLayout.includes("grid") ? (
          <div className="albums-container">
            <div className={`album-grid ${userData?.activeAlbumLayout}`}>
              {visibleAlbums.map((album, i) =>
                album?.media?.[0]?.type?.startsWith("video/") ? (
                  <div
                    key={i}
                    className="album-item customizable d-flex align-center"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      openModal("Albums", i);
                    }}
                  >
                    <video width="100%" height="auto" controls>
                      <source
                        src={album?.media?.[0]?.url}
                        type={album?.media?.[0]?.type}
                      />
                    </video>
                    <div className="album-name">{album?.name}</div>
                  </div>
                ) : (
                  <div
                    key={i}
                    className="album-item customizable"
                    onClick={() => openModal("Albums", i)}
                  >
                    <img
                      src={album?.media?.[0]?.url}
                      alt={album?.name}
                      className="album-media"
                    />
                    <div className="album-name">{album?.name}</div>
                  </div>
                ),
              )}
              {(userData?.isPremium || userData?.albums?.length < 4) && (
                <div
                  className="album-add-card"
                  onClick={() => openModal("Albums")}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </div>
              )}
              {userData.albums.length > 4 && (
                <>
                  {showAll && <div></div>}
                  <div className="text-end">
                    <button
                      className="btn px-1 py-0 btn-link"
                      onClick={() => setShowAll(!showAll)}
                      style={{ color: "rgb(108, 92, 231)" }}
                    >
                      {showAll ? "See Less" : "See All Albums"}
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="storage-bar">
              <div
                className="storage-progress"
                style={{
                  width: `${
                    (userData.storage.used / userData.storage.total) * 100
                  }%`,
                }}
              ></div>
            </div>
            <div className="storage-info">
              <span>
                {userData.storage.used} MB of {userData.storage.total} MB used
              </span>
              <span>
                {Math.round(
                  (userData.storage.used / userData.storage.total) * 100,
                )}
                %
              </span>
            </div>
          </div>
        ) : (
          <div className="album-slick-slider">
            {userData?.activeAlbumLayout === "slick1" ? (
              <Slider {...settings1x}>
                {userData.albums.map((album, i) => (
                  <div
                    key={i}
                    className="album-item customizable"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      openModal("Albums", i);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {album?.media?.[0]?.type?.startsWith("video/") ? (
                      <>
                        <video width="100%" height="auto">
                          <source
                            src={album.media[0].url}
                            type={album.media[0].type}
                          />
                        </video>
                        <button className="play-icon">
                          <FaPlay />
                        </button>
                      </>
                    ) : (
                      <img
                        src={album.media[0].url}
                        className="album-media"
                        alt=""
                      />
                    )}
                    {album?.name && (
                      <div className="album-name">{album?.name}</div>
                    )}
                  </div>
                ))}
              </Slider>
            ) : userData?.activeAlbumLayout === "slick2" ? (
              <Slider {...settings2x}>
                {userData.albums.map((album, i) => (
                  <div
                    key={i}
                    className="album-item customizable"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      openModal("Albums", i);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {album?.media?.[0]?.type?.startsWith("video/") ? (
                      <>
                        <video width="100%" height="auto">
                          <source
                            src={album.media[0].url}
                            type={album.media[0].type}
                          />
                        </video>
                        <button className="play-icon">
                          <FaPlay />
                        </button>
                      </>
                    ) : (
                      <img
                        src={album.media[0].url}
                        className="album-media"
                        alt=""
                      />
                    )}
                    {album?.name && (
                      <div className="album-name">{album?.name}</div>
                    )}
                  </div>
                ))}
              </Slider>
            ) : null}
          </div>
        )}
        <div className="section-title social-title">
          <div style={{ color: userData?.pageTheme?.titleColor }}>
            <MdOutlineWidgets /> Widget
          </div>
        </div>
        {userData?.userWidget && userData?.userWidget?.widgets?.length > 0 && (
          <WidgetComponent
            userData={userData}
            userWidget={userData?.userWidget}
            setUserData={setUserData}
            handleOpenQueueModal={handleOpenQueueModal}
            handleEditSocialClick={handleEditSocialClick}
            handleOpenEmbedAlbumModal={handleOpenEmbedAlbumModal}
            openSocialLinkThemeModal={() => openModal("Social Link Theme")}
          />
        )}
        <div className="customize-profile-content" style={{ marginTop: 24 }}>
          <h2
            className="section-title"
            style={{ color: userData?.pageTheme?.titleColor }}
          >
            <FontAwesomeIcon icon={faCog} /> Customize Your Profile
          </h2>

          <div className="customization-section">
            <div className="form-group">
              <label
                className="form-label"
                style={{ color: userData?.pageTheme?.subtitleColor }}
              >
                Personality Traits
              </label>
              <div className="traits-selector">
                {userData.tags.map((tag) => (
                  <div key={tag?._id} className="trait-wrap">
                    <button
                      className={`trait-option ${
                        tag?.isActive ? "selected" : ""
                      }`}
                      onClick={() => {
                        if (
                          !tag?.isActive &&
                          userData.tags.filter((t) => t.isActive).length === 6
                        ) {
                          toast.error("Maximum 6 active traits allowed.");
                          return;
                        }
                        updateUserData({
                          tags: userData.tags.map((t) =>
                            t._id === tag._id
                              ? { ...t, isActive: !t.isActive }
                              : t,
                          ),
                        });
                      }}
                    >
                      {tag?.name}
                    </button>
                    <button
                      className="delete-trait"
                      onClick={() => {
                        handleDeleteTraits(tag._id);
                      }}
                    >
                      <RiDeleteBin6Line size={12} />
                    </button>
                  </div>
                ))}
              </div>

              <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                <input
                  type="text"
                  placeholder="Add custom trait"
                  id="customTraitText"
                  className="form-control"
                  value={newTag || ""}
                  onChange={(e) => setNewTag(e.target.value)}
                />
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    if (!newTag?.trim()) {
                      toast.error("Please enter a valid tag.");
                      return;
                    }
                    updateUserData({
                      tags: [
                        ...userData.tags,
                        { name: newTag, isActive: false },
                      ],
                    });
                    setNewTag(null);
                  }}
                >
                  Add
                </button>
              </div>
            </div>

            {/* <div className="form-group">
              <label className="form-label">Footer Color</label>
              <div className="color-picker">
                <div
                  className="color-preview"
                  style={{
                    background: "linear-gradient(45deg, #6c5ce7, #fd79a8)",
                  }}
                ></div>
                <input
                  type="color"
                  defaultValue="#6c5ce7"
                  className="color-input"
                  onChange={(e) =>
                    (document.getElementById(
                      "profileFooter"
                    ).style.backgroundColor = e.target.value)
                  }
                />
              </div>
            </div> */}

            <div className="form-group">
              <label
                className="form-label"
                style={{ color: userData?.pageTheme?.subtitleColor }}
              >
                Theme
              </label>
              <div className="theme-selector">
                {[...themeList, ...staticThemeList]?.map((item, index) => (
                  <div
                    key={index}
                    className={`theme-option ${
                      item?.url === userData?.activeThemeUrl ? `selected` : ""
                    }`}
                  >
                    <img
                      src={item?.url}
                      alt="Theme 1"
                      className="theme-preview"
                      onClick={() => {
                        if (item?.isPremium && userData?.isPremium) {
                          setUserData((u) => ({
                            ...u,
                            activeThemeUrl: item?.url || "",
                          }));
                          updateUserData({ activeThemeUrl: item?.url });
                        } else if (!item?.isPremium) {
                          setUserData((u) => ({
                            ...u,
                            activeThemeUrl: item?.url || "",
                          }));
                          updateUserData({ activeThemeUrl: item?.url });
                        } else {
                          toast.info(
                            "This is a premium theme. Please upgrade to access.",
                          );
                        }
                      }}
                    />
                    {item?.isPremium && !userData.isPremium && (
                      <div className="theme-lock">
                        <FontAwesomeIcon icon={faLock} />
                      </div>
                    )}
                    {item?._id && (
                      <div className="custom-theme">Custom Theme</div>
                    )}
                    {item?._id && (
                      <div
                        className="theme-delete"
                        onClick={(e) => handleDeleteTheme(e, item?._id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="custom-theme-upload">
                <input
                  type="file"
                  id="customThemeInput"
                  accept="image/*"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={(e) => {
                    handleUploadCustomTheme(e);
                  }}
                />
                <button
                  className={`custom-theme-button ${
                    userData.isPremium ? "" : "premium-only"
                  }`}
                  onClick={() => {
                    if (userData?.isPremium) {
                      fileInputRef.current?.click();
                    } else {
                      toast.info(
                        "This is a premium feature. Please upgrade to access.",
                      );
                    }
                  }}
                >
                  {" "}
                  <FontAwesomeIcon icon={faUpload} /> Upload Custom Theme
                </button>
              </div>
            </div>

            <div
              className="premium-banner"
              style={{ display: userData.isPremium ? "none" : "flex" }}
            >
              <div>
                <h3>Unlock Premium Features</h3>
                <p>
                  Auto-Play Albums, up to 5mins audio, more storage and unlock
                  the bigger world of widgets
                </p>
              </div>
              <button
                className="btn"
                onClick={() => navigate("/user/dashboard?tab=shop")}
              >
                Upgrade Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="footer"
        id="profileFooter"
        style={{ backgroundColor: "#6c5ce7", color: "white" }}
      >
        <div className="d-flex align-items-center justify-content-around flex-wrap gap-2 mb-1 footer-buttons">
          <button
            type="button"
            className="btn"
            onClick={() =>
              window.open("https://t.me/biomenewsupdates", "_blank")
            }
          >
            <BsFillSendFill size={24} />
            <span>Updates</span>
          </button>
          <button type="button" className="btn">
            <RxDashboard size={24} />
            <span>Library</span>
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => setOpenWidgetModal(true)}
          >
            <FaPlus size={24} />
            <span>Widget</span>
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => openModal("Page Design Theme")}
          >
            <MdOutlineDesignServices size={24} />
            <span>Design</span>
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => navigate(`/${userData.nickname.replace(/^@/, "")}`)}
          >
            <VscPreview size={24} />
            <span>Preview</span>
          </button>
        </div>
        <p className="mb-0">
          Like the concept or can't find something? Feedback{" "}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeCg85wNG7B4a7vAD7V4c8Z8Flu7csh7ZdM0JxHDQEO-8M2uQ/viewform" // replace with your form link
            target="_blank"
            rel="noreferrer"
            style={{ color: "white", textDecoration: "underline" }}
          >
            Here
          </a>
          . Powered by{" "}
          <a href="/" style={{ color: "white" }}>
            BioME.com
          </a>{" "}
          <a
            href="/biome/terms-condition"
            style={{ color: "white", textDecoration: "underline" }}
          >
            tnc
          </a>
        </p>
      </div>
      {/* <button
        type="button"
        className="preview-profile-btn"
        onClick={() => navigate(`/${userData.nickname.replace(/^@/, "")}`)}
      >
        👁️ Preview
      </button> */}
      {showCropModal && (
        <div className="modal" style={{ display: "flex" }}>
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={() => setShowCropModal(false)}
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <h3 className="modal-title">Crop Image</h3>
            <div style={{ position: "relative", height: "400px" }}>
              {imageSrc && (
                <Cropper
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={9 / 16} // Mobile aspect ratio
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
              )}
            </div>
            <div className="mt-3">
              <Button
                variant="primary"
                onClick={handleCropSave}
                disabled={loading}
              >
                {loading ? "Uploading..." : "Save & Upload"}
              </Button>
            </div>
          </div>
        </div>
      )}
      {modal.open && (
        <FormModal
          modal={modal}
          modalForm={modalForm}
          setModalForm={setModalForm}
          closeModal={closeModal}
          saveModal={saveModal}
          userData={userData}
          deleteSocial={deleteSocial}
          deleteAlbums={deleteAlbums}
          uploadPreview={uploadPreview}
          setUploadPreview={setUploadPreview}
        />
      )}
      {openWidgetModal && (
        <WidgetMenu
          userData={userData}
          setUserData={setUserData}
          openAddSocial={openAddSocial}
          updateUserData={updateUserData}
          openWidgetModal={openWidgetModal}
          setOpenWidgetModal={setOpenWidgetModal}
          openAlbumModal={() => openModal("Albums")}
          setShowCountdownModal={setShowCountdownModal}
          setShowAlbumEmbedModal={setShowAlbumEmbedModal}
          setAlbumEmbedFormData={setAlbumEmbedFormData}
        />
      )}
      {showCountdownModal && (
        <CountdownModal
          show={showCountdownModal}
          onClose={() => handleCloseCountdownModal()}
          setUserData={setUserData}
          queueFormData={queueFormData}
          setQueueFormData={setQueueFormData}
        />
      )}
      {showAlbumEmbedModal && (
        <AlbumEmbedModal
          show={showAlbumEmbedModal}
          onClose={() => handleCloseAlbumEmbedModal()}
          userData={userData}
          setUserData={setUserData}
          albumEmbedFormData={albumEmbedFormData}
          setAlbumEmbedFormData={setAlbumEmbedFormData}
        />
      )}
    </div>
  );
}

export default CustomProfile;
